import { Navigate } from 'react-router-dom'

/**
 * Redirect from /employer/* routes to /employers/* routes
 * This component extracts path parameters and redirects to the new route structure
 */
export default function RedirectToEmployers() {
  const location = window.location.pathname.replace('/employer/', '/employers/')
  
  return <Navigate to={location} replace />
}
